import { Injectable } from '@angular/core';
import { firstValueFrom, map } from 'rxjs';

import { TagApi } from '../../api/tag.api';
import { Tag } from '../../models/tag.interface';
import { Store } from '../../../../shared/store';
import { TagState } from './tag.state';

const tagState = new TagState();

@Injectable({ providedIn: 'root' })
export class TagStore extends Store<TagState> {
  tags$ = this.state$.pipe(map((s) => s.tags));

  constructor(private tagApi: TagApi) {
    super(tagState);
  }

  setTags(nextTags: Tag[]): void {
    this.setState({ ...this.state, tags: nextTags });
  }

  async getTags(): Promise<void> {
    try {
      const fetchedTags: Tag[] = await firstValueFrom(this.tagApi.getTags$());
      this.setTags(
        fetchedTags.sort((t1, t2) => {
          return t1.name < t2.name ? -1 : +1;
        })
      );
    } catch (err) {
      this.setTags([]);
    }
  }
}
